import { validate } from 'uuid';
import { createSchema, CustomParsingError, failure, success } from 'typegate';

export const uuid = createSchema((value: unknown) => {
  if (typeof value === 'string') {
    if (validate(value)) {
      return success(value);
    }
  }
  return failure(CustomParsingError.from('UUID', value));
});
